import React from 'react'
import { Field } from 'redux-form'
import { pt, buildPropTypes } from 'common-data/proptypehelpers'
import { FieldLayoutBox } from './FieldLayoutBox'
import { FieldValueFormatter, FieldValueParser } from './FieldValueConverters'
import { FormBoxContext } from './FormBoxContext'
// import _ from 'common-tools/LodashHelper'

class CustomBoxClass extends React.Component {
  static contextType = FormBoxContext
  static propTypes = buildPropTypes([

  ], {
    children: pt.func.isRequired,
    noLayout: pt.bool.isRequired
  })

  static defaultProps = {
    noLayout: false
  }

  render () {
    const { children, noLayout, ...rest } = this.props

    if (noLayout === true) {
      const { input: { value, onChange, onBlur, name, onFocus }, meta, hide } = rest
      const { loading } = this.context

      if (hide) {
        return null
      }

      let showError = meta.touched && meta.error
      let errorMessage = showError ? meta.error || '' : ''

      return children({
        showError,
        errorMessage,
        value,
        onChange,
        onBlur,
        name,
        onFocus,
        loading
      })
    } else {
      return (
        <FieldLayoutBox {...rest}>
          {children}
        </FieldLayoutBox>
      )
    }
  }
};

export const CustomBox = ({ fieldType, name, namePrefix, ...rest }) => { return <Field name={namePrefix ? `${namePrefix}.${name}` : name} parse={FieldValueParser(fieldType)} format={FieldValueFormatter(fieldType)} {...rest} component={CustomBoxClass} /> } // eslint-disable-line
export default CustomBox
